import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Browse } from './pages/Browse';
import { AuthProvider } from './hooks/useAuth';
import { PinProvider } from './hooks/usePinGate';
import AuthGuard from './components/auth/AuthGuard';
import PinGuard from './components/auth/PinGuard';
import PinPage from './pages/PinPage';
import HelloPage from './pages/HelloPage';
import './styles/index.css';

function App() {
  return (
    <PinProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/pin" element={<PinPage />} />
              <Route path="/hello" element={<HelloPage />} />
              <Route
                path="/"
                element={
                  <PinGuard>
                    <AuthGuard>
                      <Browse />
                    </AuthGuard>
                  </PinGuard>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </PinProvider>
  );
}

export default App;
